import { Link, useParams } from "react-router-dom";
import { MapPin, CalendarDays } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { PageHero, Prose, DemoBadge } from "@/components/common";
import { ActivityRow } from "@/components/ActivityCard";
import ShareBar from "@/components/ShareBar";
import NotFound from "@/pages/NotFound";
import useTitle from "@/lib/useTitle";
import { fmtDay } from "@/lib/time";

export default function Iniciativa() {
  const { slug } = useParams();
  const { data } = useSite();
  const e = data.events.find((x) => x.slug === slug);
  useTitle(e?.title || "Iniciativa");
  if (!e) return <NotFound />;
  const acts = data.activities.filter((a) => a.event_id === e.id);
  return (
    <>
      <PageHero eyebrow="Semana da Saúde Mental" title={e.title} tone="#1d4ed8" image={e.image}>
        <div className="flex flex-wrap gap-5"><span className="inline-flex items-center gap-2"><CalendarDays className="h-5 w-5" aria-hidden />{e.date_label || (e.date_start === e.date_end ? fmtDay(e.date_start) : `${fmtDay(e.date_start, false)} a ${fmtDay(e.date_end, false)}`)}</span><span className="inline-flex items-center gap-2"><MapPin className="h-5 w-5" aria-hidden />{e.location}</span></div>
      </PageHero>
      <div className="container-x py-12 grid gap-10 lg:grid-cols-12" data-testid="initiative-page">
        <div className="lg:col-span-7"><DemoBadge show={e.demo} label="Em desenvolvimento" className="mb-4" /><Prose text={e.description} className="text-base md:text-lg" /><div className="mt-8"><ShareBar title={e.title} path={`/semana/${e.slug}`} /></div></div>
        <div className="lg:col-span-5">
          <h2 className="font-display text-2xl font-extrabold mb-4">Programação associada</h2>
          {acts.length ? <div className="grid gap-3">{acts.slice(0, 8).map((a) => <ActivityRow key={a.id} act={a} />)}</div> : <p className="text-slate-600">Programação a anunciar.</p>}
          {acts.length > 8 && <Link to="/programacao" className="mt-4 inline-block font-bold underline">Ver toda a programação</Link>}
        </div>
      </div>
    </>
  );
}
